var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.9062C14.9188 18.9062 18.9062 14.9188 18.9062 10C18.9062 5.08121 14.9188 1.09375 10 1.09375C5.08121 1.09375 1.09375 5.08121 1.09375 10C1.09375 14.9188 5.08121 18.9062 10 18.9062Z",
    fill: "#FEDA2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 16.8657C13.7922 16.8657 16.866 13.7918 16.866 10C16.866 6.20825 13.7922 3.1344 10.0004 3.1344C6.20861 3.1344 3.13477 6.20825 3.13477 10C3.13477 13.7918 6.20861 16.8657 10.0004 16.8657Z",
    fill: "#FCAA17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 4.72375L11.5615 7.88751L15.0527 8.39485L12.5265 10.8575L13.1229 14.3347L10.0001 12.693L6.87727 14.3347L7.47367 10.8575L4.94727 8.39485L8.43867 7.88751L10.0001 4.72375Z",
    fill: "#FEDA2C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.81e5f99a477384803d92cee8f6fe25de.svg";
export { ForwardRef as ReactComponent };